import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import SocialButton from './social-button';
import { FaLinkedin, FaInstagram, FaFacebookSquare, FaTwitter } from 'react-icons/fa'; 

const SocialButtons = () => {
  const data = useStaticQuery(graphql`
    query SocialQuery {
      contact: sanityContactDetails {
        social {
          facebook
          instagram
          linkedin
          twitter
        }
      } 
    }
  `);

  return (
    <>
      {
        data.contact.social.facebook &&
        <SocialButton 
          icon={<FaFacebookSquare/>}
          url={data.contact.social.facebook}
        />
      }

      {
        data.contact.social.twitter &&
        <SocialButton
          icon={<FaTwitter/>}
          url={data.contact.social.twitter}
        />
      }

      {
        data.contact.social.instagram &&
        <SocialButton 
          icon={<FaInstagram/>}
          url={data.contact.social.instagram}
        />
      }

      {
        data.contact.social.linkedin &&
        <SocialButton 
          icon={<FaLinkedin/>}
          url={data.contact.social.linkedin}
        />
      }
    </>
  )
}

export default SocialButtons;